export default "__VITE_ASSET__DSidWjbZ__"